import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../Link';
import { SideMenuDashboardIcon } from '../../Common/Assets/SvgIconComponent/SideMenuIcons';
import { SideMenuManageCarsIcon, SideMenuManageReservationsIcon, SideMenuPayoutManagementIcon, SideMenuMessagesIcon } from '../../Common/Assets/SvgIconComponent/SideMenuRemainingIcons';
import messages from '../../../locale/jsonMessages';
import { OWNER_MENU_PATHS, getOwnerMenuActive } from './ownerMenuItems';
import s from './OwnerSideMenu.css';

const ICONS = {
  dashboard: SideMenuDashboardIcon,
  vehicles: SideMenuManageCarsIcon,
  reservations: SideMenuManageReservationsIcon,
  earnings: SideMenuPayoutManagementIcon,
  messages: SideMenuMessagesIcon,
};

// Side menu of the owner space (D14): Dashboard, My vehicles, Reservations (upcoming / previous), Revenue & payouts, Messages.
// `activePath` comes from the route (the pathname of the page being rendered). Nothing else decides who sees it: the pages that
// render it already require a logged-in user (same rule as /cars and /reservation/*).
export const OwnerSideMenu = ({ activePath }) => {
  const { formatMessage } = useIntl();
  const { section } = getOwnerMenuActive(activePath);
  const entries = [
    { key: 'dashboard', to: OWNER_MENU_PATHS.dashboard, label: messages.ormDashboard },
    { key: 'vehicles', to: OWNER_MENU_PATHS.vehicles, label: messages.ormVehicles },
    { key: 'reservations', to: OWNER_MENU_PATHS.upcoming, label: messages.ormReservations },
    { key: 'earnings', to: OWNER_MENU_PATHS.earnings, label: messages.ormEarnings },
    { key: 'messages', to: OWNER_MENU_PATHS.messages, label: messages.ormMessages },
  ];
  return (
    <nav className={s.menu} aria-label={formatMessage(messages.ormMenuLabel)} data-owner-menu="true">
      <ul className={s.list}>
        {entries.map((entry) => {
          const active = section === entry.key;
          const Icon = ICONS[entry.key];
          // Reservations covers two pages (upcoming, previous): it is "the current section" (true), not "the page"
          const ariaCurrent = !active ? undefined : (entry.key === 'reservations' ? 'true' : 'page');
          return (
            <li key={entry.key} className={cx(s.item, active && s.itemActive)}>
              <Link to={entry.to} className={cx(s.link, active && s.linkActive)} aria-current={ariaCurrent}>
                <span className={s.icon} aria-hidden="true"><Icon /></span>
                <span className={s.label}>{formatMessage(entry.label)}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

OwnerSideMenu.propTypes = {
  activePath: PropTypes.string,
};

// Column that holds the page next to the menu, for the pages that are not already a column (inbox, dashboard, revenue).
export const OwnerMenuContent = ({ children }) => (
  <div className={cx('col-xs-12', 'col-sm-12', 'col-md-9', 'col-lg-10', s.content)}>{children}</div>
);

OwnerMenuContent.propTypes = {
  children: PropTypes.node,
};

export default withStyles(s)(OwnerSideMenu);
